import {CommentsDisabledOutlined} from "@mui/icons-material";

export default class GenericTextValue {
  constructor(name, initialValue, namespace) {
    this.currentValue="";
    this.namespace=namespace;
    this.name=name;
    this.value="@value";
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getValue() {
    return this.currentValue;
  }

  setValue(value) {
    this.currentValue=value;
  }

  getCurrentValue() {
    return this.currentValue;
  }

  setCurrentValue(value) {
    this.currentValue=value;
  }

  getExpandedFormatValue(isNumber) {
    return [{[this.value]: isNumber?Number(this.getCurrentValue()):this.getCurrentValue()}];
  }

  isEmpty() {
    return !this.getCurrentValue();
  }

  parseInputJSON(inputJSON) {
    if (!inputJSON||!inputJSON[this.namespace]) {
      return;
    }
    const valueArray=inputJSON[this.namespace][0];
    this.setCurrentValue(valueArray[this.value]);
  }
}
